<template>
  <div class="page-maxwidth">
    <div class="my-3" v-html  ="text" />
    <div class="results position-relative">
      <carousel :breakpoints="breakpoints" ref="carouselRef" aria-label="Fortbildungen & Veranstaltungen" tabindex="">
        <slide
          v-for="result in dataStore?.data?.data"
          :key="result.semnr"
          v-if="dataStore?.data?.num_items"
          aria-hidden="false"
          role="listitem"
        >
          <PreviewResult :result="result" />
        </slide>
      </carousel>
      <div class="row">
        <div class="col-6">
          <a :href="listLink">HIER FINDEN SIE ALLE VERANSTALTUNGEN</a>
        </div>
        <div class="col-6 text-end">
          <button @click="SlideCarousel('prev')" class="clearbutton" aria-label="Zurück">
            <i class="fas fa-angle-double-left" aria-hidden="true"><span class="sr-only">zurück</span></i></button
          >&nbsp;
          <button @click="SlideCarousel('next')" class="clearbutton" aria-label="Weiter">
            <i class="fas fa-angle-double-right" aria-hidden="true"><span class="sr-only">weiter</span></i>
          </button>
        </div>
      </div>
      <h5 v-if="dataStore?.data?.num_items === 0">Keine Ergebnisse gefunden</h5>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted} from "vue";
import { useDataStore } from "@/store/";
import { sortVerans } from "@/shared/utils";
import "vue3-carousel/dist/carousel.css";
import { Carousel, Slide, Pagination, Navigation } from "vue3-carousel";
import PreviewResult from "@/components/Veranstaltungen/PreviewResult";

const dataStore = useDataStore();
const text = typeof maintext === "undefined" ? ref("") : ref(maintext);
const listLink = typeof listURL === "undefined" ? ref("") : ref(listURL);
const carouselRef = ref();

const breakpoints = {
  0: {
    itemsToShow: 1,
    snapAlign: "center",
  },
  768: {
    itemsToShow: 2,
    snapAlign: "center",
  },
  992: {
    itemsToShow: 3,
    snapAlign: "start",
  },
};

const SlideCarousel = (value) => {
  const carousel = carouselRef.value;
  const currentSlide = carousel.data.currentSlide.value;
  const slideCount = carousel.data.slidesCount.value;
  const itemsToShow = carousel.data.config.itemsToShow;
  if (value == "prev") {
    currentSlide != 0
      ? carousel.slideTo(currentSlide - 1)
      : carousel.slideTo(slideCount - 1);
  } else {
    currentSlide < slideCount - itemsToShow
      ? carousel.slideTo(currentSlide + 1)
      : carousel.slideTo(0);
  }
};


const apiPointOut =
  typeof apiPoint === "undefined"
    ? "http://akberlin:8888/fuer-mitglieder/aus-fort-und-weiterbildungaus-fort-und-weiterbildung/forbildung/veranstaltungen?tx_apis_calluniplus%5Baction%5D=callUniplus&tx_apis_calluniplus%5Bcontroller%5D=X3&tx_apis_calluniplus%5Bpath%5D=seminarwesen%2Fkurse%2F&type=871&cHash=7ba794e3bbef8570902b47cb1c8fe9a2"
    : apiPoint;

onMounted(() => {
  dataStore.setUrl(process.env.VUE_APP_API_BASE + apiPointOut);
  dataStore.setParams({
    startseite: "J",
  });
  
  dataStore.callApi({
    afterEnd: () => {
      const results = dataStore?.data?.data;
      if (!results) return;
      results.sort((a, b) => new Date(b.date) - new Date(a.date));
      dataStore.setData({ ...dataStore.data, data: results });
    },
  });
});
</script>
